import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatSortModule } from '@angular/material/sort';
import { LoadingModule } from 'app/main/components/general/loading/loading.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ImageViewerComponent } from './image-viewer.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [ImageViewerComponent],
  imports: [
    MatDialogModule,
    TranslateModule,
    FuseSharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,  
    MatMenuModule,
    PerfectScrollbarModule,
    MatSortModule,
    LoadingModule,
    MatIconModule
  ],
  exports: [ImageViewerComponent],
})

export class ImageViewerModule {}
